import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function PrivateRoute({ children }) {
    const { loggedUser } = useAuth();

    if (!loggedUser) {
        return <Navigate to="/login" />;
    }

    return children;
}